import {
  CLOUDFLARE_TURNSTILE_ERROR_CODES,
  CLOUDFLARE_TURNSTILE_ERROR_CODE_PATTERNS,
} from 'lib/cloudflare_turnstile_error_codes';

const IGNORED_CLOUDFLARE_TURNSTILE_ERRORS = [
  CLOUDFLARE_TURNSTILE_ERROR_CODES.INVALID_CHALLENGE_PARAMETERS,
  CLOUDFLARE_TURNSTILE_ERROR_CODES.CLOCK_OR_CACHE_PROBLEM,
  CLOUDFLARE_TURNSTILE_ERROR_CODES.UNDOCUMENTED_400060,
  CLOUDFLARE_TURNSTILE_ERROR_CODE_PATTERNS.GENERIC_CHALLENGE_FAILURE_600,
  CLOUDFLARE_TURNSTILE_ERROR_CODE_PATTERNS.GENERIC_CHALLENGE_FAILURE_300,
  CLOUDFLARE_TURNSTILE_ERROR_CODE_PATTERNS.CHALLENGE_TIMEOUT,
];

function formatErrorCode(code: RegExp | string) {
  return code instanceof RegExp ? code.source : code;
}

const errorCodesPattern =
  IGNORED_CLOUDFLARE_TURNSTILE_ERRORS.map(formatErrorCode).join('|');
const TURNSTILE_ERROR_MESSAGE_REGEX = new RegExp(
  `\\[Cloudflare Turnstile\\] Error: (${errorCodesPattern})`,
);
const TURNSTILE_ERROR_CODE_REGEX = new RegExp(`^(${errorCodesPattern})$`);

export const shouldIgnoreTurnstileError = (code: string): boolean => {
  return TURNSTILE_ERROR_CODE_REGEX.test(code);
};

export const ignoreErrors = [
  /Cannot find component: '(\w)*'. Make sure your component is available to render./i,
  /ChunkLoadError: Loading chunk (\d)* failed/i,
  /Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node/i,
  /Failed to fetch/i,
  /^Load failed$/,
  /undefined is not an object \(evaluating 'r\.DomainData'\)/i,
  /You are not authorized to take this action/i,
  /An unexpected error has occurred, please try again later/i,
  /'unsafe-eval' is not an allowed source of script in the following Content Security Policy directive/i,
  /Can't find variable: _AutofillCallbackHandler/i,
  /ResizeObserver loop completed with undelivered notifications/i,
  TURNSTILE_ERROR_MESSAGE_REGEX,
];
